









































import { Vue, Component, Watch } from 'vue-property-decorator';
import store from '@/vuex/index';
import RongIM from '@/common/util/rongcloud';
import Bus from '@/common/util/bus';
import { WorkingTable } from '@/http';

@Component({
    components: {},
    computed: {
        myMesNum: {
            get() {
                return this.$store.state.mesNum;
            },
        },
    },
})
export default class HeaderBar extends Vue {
    public sysUserName: string = '';
    dialogVisible = false;
    handleClose() {
        this.dialogVisible = false;
    }

    @Watch('myMesNum')
    public mesNumChange() {
        console.log('有新消息');
        this.$root.$emit('newMes');
    }

    test() {
        store.dispatch('getMessage');
    }

    public userinfo = {
        type: '',
        name: '',
        userName: '',
        jobNumber: '',
        phone: '',
        enterpriseName: '',
    };
    sex = '';
    userName = '';
    realName = '';
    headPath = null;
    useId = null;
    adminId = null;
    departmentName = '';
    rongYunToken = '';
    isPlateform: boolean = false;
    logo: boolean = false;
    admin: boolean = true;
    gretting = '';
    ry: any;
    timer: any;
    showTalk = false;
    public isOpenTencentCloud = false;

    public datavShow: boolean = false;

    mounted() {
        console.log('11');
        this.userName = sessionStorage.getItem('userName')
            ? sessionStorage.getItem('userName')
            : JSON.parse(localStorage.getItem('mlssloginAd')).userName;
        this.realName = sessionStorage.getItem('realName')
            ? sessionStorage.getItem('realName')
            : JSON.parse(localStorage.getItem('mlssloginAd')).realName;
        this.bodyScale();
        window.onresize = () => {
            this.bodyScale();
        };
        console.log('22');
        //融云
        // this.rongYunToken = JSON.parse(localStorage.getItem('mlssloginAd')).webRongYunToken;
        // console.log('this.rongYunToken~~~~~~~~~~~~~~~' + this.rongYunToken);
        // if (this.rongYunToken) {
        //     this.ry = new RongIM(this.rongYunToken);
        //     this.ry.init();
        // }
        //websocket
        // this.initWebSocket();
        this.datavShow = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus.includes('sjkb2');
    }
    bodyScale() {
        var devicewidth = document.documentElement.clientWidth;
        if (devicewidth <= 1400) {
            this.collapsed = true;
            this.$root.$emit('foldFunc', this.collapsed);
        } else {
            this.collapsed = false;
            this.$root.$emit('foldFunc', this.collapsed);
        }
    }
    //退出登录
    logOut() {
        this.$confirm('确认退出吗?', '提示', {
            type: 'warning',
        })
            .then(() => {
                location.reload();
                store.state.isFirst = true;
                sessionStorage.clear();
                localStorage.clear();
                store.dispatch('bread/clearBreadList');
                this.$router.push('./login');
                this.ry.disconnect();
            })
            .catch(() => {});
    }

    toDashboard() {
        this.$router.push('/dashboard');
    }
    public collapsed: boolean = false;
    foldFunc() {
        this.collapsed = !this.collapsed;
        this.$root.$emit('foldFunc', this.collapsed);
    }

    //websocket
    public websocket: any;
    socketURL: any = '';
    async initWebSocket() {
        let res = await WorkingTable.PreConnect();
        this.socketURL = res.extData;
        //初始化
        this.websocket = new WebSocket(this.socketURL);
        var that = this.websocket;
        that.onopen = this.websocketonopen;
        that.onerror = this.websocketonerror;
        that.onmessage = this.websocketonmessage;
        that.onclose = this.websocketclose;
    }
    websocketonopen() {
        //发送
        console.log('WebSocket连接成功');
        this.socketSend();
    }
    websocketonerror(e) {
        //错误
        console.log('WebSocket连接发生错误');
        console.log('e' + e);
        // this.initWebSocket();
    }
    websocketonmessage(res) {
        let temp = JSON.parse(res.data);
        console.log('接收的数据', temp);
        if (temp.ImType == 1) {
            this.$notify({
                title: temp.Notcie.NoticeType,
                message: temp.Notcie.Title,
                type: 'success',
            });
        } else {
            this.$notify({
                title: temp.SystemMsg.DataTypeStr,
                message: temp.SystemMsg.Content,
                type: 'success',
            });
        }
        this.$root.$emit('newMes');
    }
    public socketSend() {
        this.timer = setInterval(() => {
            try {
                this.websocket.send('Ping');
                console.log('Ping');
            } catch {
                console.log('断开连接~~~~');
                this.websocket.close();
                this.initWebSocket();
            }
        }, 20000);
    }
    beforeDestroy() {
        clearInterval(this.timer);
    }

    websocketclose(e) {
        //关闭
        console.log('断开连接', e);
        // this.websocket.close();
        // this.initWebSocket();
    }

    destroyed() {
        //页面销毁时关闭
        if (this.websocket) {
            this.websocket.close();
        }
    }

    getDatav() {
        let routeUrl = this.$router.resolve({
            path: '/datav',
        });
        window.open(routeUrl.href, '_blank');
    }
    getDashboard(){
        this.$router.push('/dashboard')
    }
}
